export const onBoardingSignaturePositionTourBase = {
	steps: [
		{
			title: 'envelope.signature.onBoardingPosition.step-automatic.title',
			description: 'envelope.signature.onBoardingPosition.step-automatic.desc',
			element: {
				selector: '.auto-section',
			}
		},
		{
			title: 'envelope.signature.onBoardingPosition.step-manual.title',
			description: 'envelope.signature.onBoardingPosition.step-manual.desc',
			element: {
				selector: '.manual-section',
			}
		}
	]
};

export const onBoardingFormFieldsStep = {
	title: 'envelope.signature.onBoardingPosition.step-form.title',
	description: 'envelope.signature.onBoardingPosition.step-form.desc',
	element: {
		selector: '.form-section',
	}
};

export const onBoardingSignaturePositionTourOptions = {
	counter: {
		showCounter: true,
		textOf: 'envelope.signature.onBoardingPosition.textOf'
	},
	actionButtons: {
		prev: {
			text: 'envelope.signature.onBoardingPosition.btnPrev'
		},
		next: {
			text: 'envelope.signature.onBoardingPosition.btnNext',
			textComplete: 'envelope.signature.onBoardingPosition.btnComplete'
		},
		close: {
			hasButtonClose: true
		}
	}
};